import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class AetQuizAddService extends BaseService {
  constructor() {
    super(constants.ADD_AET_QUESTION_DATA, 'AetQuizAddStatus');
    this.fetchPayload = null;
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);

    // Exclude rawResponse from payload before sending to API
    const { rawResponse, ...apiPayload } = payload;

    // Get tenantId from payload or headers
    const tenantId = payload.tenantId || headers[constants.BERLIN_TENANT_ID_HEADER];

    // Store fetch payload for refetching after successful addition
    this.fetchPayload = {
      bookId: payload.bookId,
      pageId: payload.pageId,
      tenantId,
      questionNumber: 1
    };

    return this.getClient('aiadminv2').post(`/cm/quiz-aet/addquestion`, apiPayload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const notification = {
        open: true,
        type: 'success',
        message: 'AET Question Added successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('aetQuizUtility').setAddAetQuestionResponse(response.data);

      // Refetch the updated data to show in UI
      if (this.fetchPayload) {
        Framework.getStoreRegistry().getStore('aetQuizUtility').fetchAetQuiz(this.fetchPayload);
      }
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('aetQuizUtility').resetStoreValues();
  }
}
